import { FC } from 'react';
import { useVgsFormErrorMessage } from 'obt-common';
import { InputLabel } from '@spotnana/blocks/src/InputLabel';
import ErrorLabel from './ErrorLabel';
import { secure_input_container, vgs_field_content_iframe } from './SecureInput.styles';

interface IProps {
  label: string;
  id: string;
  dataTestId?: string;
  errorMessage?: string;
}

const SecureInput: FC<IProps> = ({ label, id, dataTestId, errorMessage }: IProps) => {
  const sanitizedErrorMessage = useVgsFormErrorMessage(errorMessage, label);

  return (
    <>
      <InputLabel required htmlFor={id}>
        {label}
      </InputLabel>

      <div css={secure_input_container(Boolean(errorMessage))}>
        {/* VGS will insert its card detail fields as an iframe in this div */}
        <div css={vgs_field_content_iframe} id={id} data-testid={dataTestId} />
      </div>
      {sanitizedErrorMessage && <ErrorLabel dataTestId={`${dataTestId}-error-msg`} message={sanitizedErrorMessage} />}
    </>
  );
};

export default SecureInput;
